import { render, staticRenderFns } from "./FilesAppSettings.vue?vue&type=template&id=72195bd8"
import script from "./FilesAppSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesAppSettings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports